<template>
  <header>
    <div id="headerContainer">
      <img src="tebucks_logo.png" alt="Tenmo Logo" />
    </div>
  </header>
</template>

<script>
export default {
  name: "HeaderSection"

}
</script>

<!-- <style scoped>
header {
    background-color: #fff;
    display: flex;
    flex-wrap: wrap;
    box-sizing: border-box;
    margin-left: 0;
    margin-right: 0;
    align-items: center;
}

img {
    width: 200px;
}
</style> -->